module.exports = __webpack_public_path__ + "static/media/checkbox-empty.93085941.svg";